import React from 'react';
import './App.css';

import Routes from './routes';

const App: React.FC = () => {
  return (
    <div>
      <Routes />
    </div>
  );
};

export default App;
